import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserModel } from 'app/models/user.model';
import { ApiService } from 'app/shared/apis/api.service';
import { ErrorDialogComponent } from 'app/shared/dialogs/error-dialog/error-dialog.component';
import { of, switchMap, take } from 'rxjs';

export const CanAccessFinanceGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const matDialog = inject(MatDialog);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user: UserModel) => {
            // Admin bypass: admins have access to everything
            if (user?.isAdmin) {
                return of(true);
            }
            // Check if user has permission to access finance
            if (user?.permission?.can_access_finance) {
                return of(true);
            }

            // Show error dialog for users without permission
            matDialog.open(ErrorDialogComponent, {
                data: {
                    message: 'Você não tem permissão para acessar o financeiro. Entre em contato com o administrador.',
                },
            });

            // Redirect to wallet page
            return of(router.parseUrl('/wallet'));
        }),
    );
};

